<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands =
[{"num_cand":"U2FsdGVkX18GiaKQ2ClJ4+tJZmfkFTI7zvQnBKiYB8A=","cpf":"U2FsdGVkX19vqtzM0K5zSiTvtW34BUQnwJZvSaQkQBk="},{"num_cand":"U2FsdGVkX1/1DRFNqvags7YNJ76EB56IaWNK1wbVltA=","cpf":"U2FsdGVkX1/jrceNFG9YhsJKVaOElF/pqghlDihkNcg="},{"num_cand":"U2FsdGVkX1+DbJx+VGk0wxVx5sIHGIqnMInlFbH4cyw=","cpf":"U2FsdGVkX1+tiOZb7dQkOHSpxwKeN+987rHaDGchcx0="},{"num_cand":"U2FsdGVkX1/jY581Ib2UYSSS4uuaQphkJg7oKbjNZ6s=","cpf":"U2FsdGVkX18bCg0QUwJ4a4qlicy8jymPKWDqvXsXD18="},{"num_cand":"U2FsdGVkX1/H4Ya+WGh6mDOFbkfou2MiYbTTxUUQouA=","cpf":"U2FsdGVkX18r+w14TuLPjJ5/v7KdCbp203gO0h9Ba+Y="},{"num_cand":"U2FsdGVkX1+q8pPI6j5oaG+QZTF+fbJQC7Z8rABilmQ=","cpf":"U2FsdGVkX18rJ8kq0kueeq+jgrHEMxxetJK2Q03N5Wg="},{"num_cand":"U2FsdGVkX1/SbngmbH46UJyy2vySKtdKZ2g8dH5qvfc=","cpf":"U2FsdGVkX1/Im44zcwN00MhhiRCX2PF6jC78EY0dXQY="},{"num_cand":"U2FsdGVkX1/JFyjei8kqgtKxMlZA2st+2GJVqfiDsW4=","cpf":"U2FsdGVkX19as6AD4bZsHbOd0s6erkCCpxD89ii973o="},{"num_cand":"U2FsdGVkX18UwcY4EF9kPP1J2F2pQb1FvnXvspxmuAg=","cpf":"U2FsdGVkX19A8AxzrG55+PF9BhF/lKqz3M9R6DOB2L8="},{"num_cand":"U2FsdGVkX18TeCV0zFEAR7YLgA+uNCjlVRiCpeLJYZQ=","cpf":"U2FsdGVkX1+0Rh1rd5kXt7AAfPsQvUSSIY6c4TN/5l0="},{"num_cand":"U2FsdGVkX19UxtdkVnFmcQAq1pjPuY+t8qe7OEnW7UU=","cpf":"U2FsdGVkX1/c747kcpPNhk8dq0KLCceJhYRDUQ+vJ+4="},{"num_cand":"U2FsdGVkX18Va9Ai/OHJLlZh0PZt7d0rCkzBwkVkCRc=","cpf":"U2FsdGVkX1/1xhBBHAXOUxYAxeNK6BKc+D7hoFh0qbk="},{"num_cand":"U2FsdGVkX19MawkA1e3FPDCjFsq6Xw18VPEY9Bcnlbs=","cpf":"U2FsdGVkX1+8BKCIk2tZ5sTIJbfdhlz7IY72kTuck6c="},{"num_cand":"U2FsdGVkX19o3losIQAn997a95natLOpk9TmjYrsVgw=","cpf":"U2FsdGVkX19AQlrt69DopnFw9NsrvtPo11u2+VbF3Yo="},{"num_cand":"U2FsdGVkX1/4UPqLqSGwDYiIDTfPGIe1qlxUfT0/J7c=","cpf":"U2FsdGVkX1/jy/xV37NUV4zR0EivaCEEb3cngSz4TcY="},{"num_cand":"U2FsdGVkX190ol4AB8FAokK0R2wxb3hW4IehmcDo9XA=","cpf":"U2FsdGVkX1/6FdoWBDiNteeOyZXl/2yr0JFcr+QbHsY="},{"num_cand":"U2FsdGVkX1+ORnVX7CXT9vrl12oDEig6F0q5BlV5xpI=","cpf":"U2FsdGVkX1//R1ZBv7FtCRzvxFcXN3xPqh/91qHJViQ="},{"num_cand":"U2FsdGVkX19PBXqa5NxuqAGnOVozwaeRaGrAbmAX1jY=","cpf":"U2FsdGVkX18CTJ2+mtRTvZVtS9Z+uiXW73+2uRukEmk="},{"num_cand":"U2FsdGVkX1/f7SI48+chMS+gM8vgporVA8WSP9ewEVI=","cpf":"U2FsdGVkX1/XNkbWaMgpkZVnTeZheixAiHBB6PGKGck="},{"num_cand":"U2FsdGVkX1/VlLRrJT8dN2bs10chd9zA4Ar/X7sjfLU=","cpf":"U2FsdGVkX18aTNMPWhjZfQKrzB8Z+1ZT+rn8FXIxfRg="},{"num_cand":"U2FsdGVkX1/kMbY9/VipOf0jLXzUsF5/OJI9ilxBHao=","cpf":"U2FsdGVkX1+fDjll1CUmMyZzCw7Fz0mlIhI3biiz6qo="},{"num_cand":"U2FsdGVkX1+kPZwK3AUKSu+wiurTtDnWtuJkOIkhuw8=","cpf":"U2FsdGVkX1/HN0OoESZtv2b9VrR93yiflBYne9U02tw="},{"num_cand":"U2FsdGVkX19yAevWVV3tPJy/k3j7Qy9UNcBeM02cLNs=","cpf":"U2FsdGVkX198LS9kTD9cikz4hyO96XPtSCzuUB/2a90="},{"num_cand":"U2FsdGVkX1/6WinSdzbj+5aHh2+M0mqJDKK7C8A8dhI=","cpf":"U2FsdGVkX1+JQnDv46joIAvIWPiZFi9z09zOuzxUUGU="},{"num_cand":"U2FsdGVkX1/aGfp2D7X+17miyvQ7u1LJlZdTublEsqo=","cpf":"U2FsdGVkX19E8o/SwKrd0Q+mT6Uc6YNAWska7dy7HS8="},{"num_cand":"U2FsdGVkX1+J6qG+OQcduagN865gQl/7P5fNs1J6SQ8=","cpf":"U2FsdGVkX18gpAzH41q69Xda7ljIBwg7wFpohQ5qGKI="},{"num_cand":"U2FsdGVkX19pqLzODjxLP3SoD3zjjY2+jUlkkrBPkIA=","cpf":"U2FsdGVkX19dnPASzLUGS2MuwrqF1xky2Br9IFt6gnI="},{"num_cand":"U2FsdGVkX191wr6UjpHP5eN+VNCzXc+sBxzLelXBopo=","cpf":"U2FsdGVkX1/tfJJQu2c1xUi+Ad/rEtPJZOWnfUDWUJc="},{"num_cand":"U2FsdGVkX182q7JYcX2d9uQ3joSzAMI4Q6U838euHOI=","cpf":"U2FsdGVkX18mMh+vRYlBbTaaqJ1wpNBXPeGV4PUnm04="},{"num_cand":"U2FsdGVkX18JeoG5KBUnWF1X/dU+0dCfPfmP8e+zuAs=","cpf":"U2FsdGVkX1+uT8N77ZxBhCrsod6wxgZQ4aO0VojSvOg="},{"num_cand":"U2FsdGVkX1/4GZ7IIX91UBoPdjcdLt2O2Vuc86OSgZc=","cpf":"U2FsdGVkX19cL5hHkiRxeR1QVMxDu+lwDsPJmMHpp4Y="}]

      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2208/rec_PO/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
